<app-ace-select
  #aceSelect
  [items]="metadataTypes"
  [multiSelect]="multiSelect"
  [closeOnSelect]="!multiSelect"
  [maxSelectedLabels]="maxSelectedLabels"
  [maxSelectedShowItemName]="maxSelectedShowItemName"
  [maxSelectedItemName]="maxSelectedItemName"
  [truncateLabels]="truncateLabels"
  [customItemTooltip]="tooltipById?.size ? getTooltip : null"
  [bindLabel]="'type'"
  [bindValue]="bindToTypeId ? 'type_id' : null"
  [placeholder]="placeholder"
  [loading]="loading"
  [compareWith]="bindToTypeId ? null : compareFn"
  [hideSelected]="hideSelected"
  [appendTo]="appendTo"
  [clearable]="clearable"
  (openEvent)="onOpen()"
  (closeEvent)="onClose()"/>
